import React, { useEffect, useState } from 'react';
import { firebaseCollections, visibilityStatesArr } from '../Constants/Variables';
import { getAsanaProjectTasksById, sortByStatus, sortByDuedate } from '../Constants/Functions';
import { database, storage } from '../Firebase/firebase';

import AppNavbar from '../Components/AppNavbar';
import AppBanner from '../Components/AppBanner';
import LayoutControlMenu from '../Components/LayoutControlMenu';
import ActionItemCard from '../Components/ActionItemCard';

import '../Styles/Pages/Roadmap.scss';
import AppDropdown from '../Components/AppDropdown';
import AppSpinner from '../Components/AppSpinner';

function Roadmap(props) {
    // var task = {
    //     title: "Tittle of task",
    //     description: `Making IBAN field smarter in bank
    //     registration form so that it would
    //     detect from the first 2 letters the
    //     country of the bank as well as other data.
    //     This way this Read more...`,
    //     due_date: "12/12/21",
    //     percentage: 50,
    //     assignee: "Nick Dennitto",
    //     status: 'In Progress'
    // }
    const [isLoading, setIsLoading] = useState(true);
    const [selectedLayout, setSelectedLayout] = useState("Tiles");
    const [actionItemTasks, setActionItemTasks] = useState([]);
    const [roadmap2020, setRoadmap2020] = useState([]);
    const [roadmap2021, setRoadmap2021] = useState([]);
    const [selectedSortOptions, setSelectedSortOptions] = useState([
        {
            index: 0,
            active: true,
            name: "Due Date",
        },
        {
            index: 1,
            active: false,
            name: "Status",
        }
    ]);
    const [selectedTaskTypes, setSelectedTypes] = useState([
        {
            index: 0,
            active: true,
            name: "Wall Action Items",
        },
        {
            index: 1,
            active: false,
            name: "CC 2020 Roadmap",
        },
        {
            index: 2,
            active: false,
            name: "CC 2021 Roadmap",
        },
    ]);
    var selectedTaskType = selectedTaskTypes.filter(type => type.active)[0];
    var selectedSortOption = selectedSortOptions.filter(type => type.active)[0];
    var tasksVariablesArr = [actionItemTasks, roadmap2020, roadmap2021];
    var sortVariablesArr = [sortByStatus, sortByDuedate];
    // console.log(tasks)
    useEffect(() => {
        database.collection(firebaseCollections.thewall).get().then(function (querySnapshot) {
            var tasks = [];
            querySnapshot.forEach(function (doc) {
                var data = doc.data();
                if (data.asana) {
                    tasks.push(data.asana);
                }
            });
            setActionItemTasks(tasks);
            setIsLoading(false);
        });

        return () => {

        }
    }, [])

    const onTasksTypeSelect = (selectedTypeIndex) => {

        setIsLoading(true);
        selectedTaskTypes.forEach(type => {
            type.active = false;
        });
        selectedTaskTypes[selectedTypeIndex].active = true;
        setSelectedTypes([...selectedTaskTypes])

        switch (selectedTaskTypes[selectedTypeIndex].name) {
            case "Wall Action Items":
                setIsLoading(false);
                break;
            case "CC 2020 Roadmap":
                if (!roadmap2020.length) {
                    getAsanaProjectTasksById(1151867261450105).then((response) => {
                        if (response) {
                            setRoadmap2020([...response])
                        }
                        setIsLoading(false);
                    })
                } else {
                    setIsLoading(false);
                }
                break;
            case "CC 2021 Roadmap":
                if (!roadmap2021.length) {
                    getAsanaProjectTasksById(1199535348202463).then((response) => {
                        if (response) {
                            setRoadmap2021([...response])
                        }
                        setIsLoading(false);
                    })
                } else {
                    setIsLoading(false);
                }
                break;
            default:
                setIsLoading(false);
                break;
        }
    }

    const handleItemSelect = (selectedLayoutName) => {
        setSelectedLayout(selectedLayoutName);
    }

    const onSortOptionSelect = (selectedTypeIndex) => {
        selectedSortOptions.forEach(type => {
            type.active = false;
        });
        selectedSortOptions[selectedTypeIndex].active = true;
        setSelectedSortOptions([...selectedSortOptions])
    }

    return (
        <div>
            <AppNavbar {...props} />
            <AppBanner
                style={{ padding: 0 }}
                coverImgStyle={{ objectFit: 'cover', width: '100%' }}
                bannerimgsrc="/images/roadmap_cover_eve.png"
            />
            <div className="ActionBar">
                <div className="ActionBar--LeftSide">
                    <LayoutControlMenu handleItemSelect={handleItemSelect} />
                    <AppDropdown className="TaskType-Dropdown" defaultvalue={selectedTaskType.name} headertitle="Type of Tasks" items={[...selectedTaskTypes.map(type => type.name)]} alignright={true} onSelect={onTasksTypeSelect} activeindex={selectedTaskType.index} />
                </div>
                <div className="ActionBar--RightSide">
                    <AppDropdown className="Sort-Dropdown" defaultvalue={selectedSortOption.name} headertitle="Sort By" items={[...selectedSortOptions.map(type => type.name)]} alignright={true} onSelect={onSortOptionSelect} activeindex={selectedSortOption.index} />
                </div>
            </div>
            <div className={`Roadmap--ActionItems-Body-${selectedLayout}`}>
                {
                    isLoading ?
                        (
                            <AppSpinner loadingtext="SEARCHING..." />
                        ) :
                        (
                            tasksVariablesArr[selectedTaskType.index].sort(sortVariablesArr[selectedSortOption.index]).map((task) => {
                                return (<ActionItemCard
                                    key={task.id}
                                    id={task.id}
                                    selectedLayout={selectedLayout}
                                    assignee={task.assignee.name}
                                    description={task.description}
                                    title={task.title}
                                    start_date={task.start_date}
                                    due_date={task.due_date}
                                    status={task.status}
                                    percentage={task.status === "Done" ? 100 : 50}
                                />)
                            })
                        )
                }
            </div>
        </div>
    )
}

export default Roadmap;